/* TPC Shop Now: adds the selected variant + quantity to the existing cart (cart contents are kept),
   then sends the shopper to checkout. Mirrors the Add to cart button's enabled/disabled state. */
(function () {
  if (window.__tpcShopNowInit) return;
  window.__tpcShopNowInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var fallbackError = (window.tpcShopNowStrings && window.tpcShopNowStrings.error) ||
    'This item could not be added to your cart. Please refresh the page and try again.';

  function formFor(btn) {
    return document.getElementById(btn.getAttribute('data-form-id'));
  }

  function syncState(btn) {
    var form = formFor(btn);
    if (!form || btn.getAttribute('aria-busy') === 'true') return;
    var atc = form.querySelector('[name="add"]');
    var idInput = form.querySelector('input[name="id"]');
    var off = !atc || atc.disabled || !idInput || idInput.disabled || !idInput.value;
    btn.disabled = off;
  }

  function errorParts(btn) {
    var pf = btn.closest('product-form');
    if (!pf) return null;
    return {
      wrap: pf.querySelector('.product-form__error-message-wrapper'),
      msg: pf.querySelector('.product-form__error-message')
    };
  }

  function showError(btn, text) {
    var p = errorParts(btn);
    if (p && p.wrap && p.msg) {
      p.msg.textContent = text;
      p.wrap.removeAttribute('hidden');
    } else {
      window.alert(text);
    }
  }

  function clearError(btn) {
    var p = errorParts(btn);
    if (p && p.wrap) p.wrap.setAttribute('hidden', '');
  }

  function setBusy(btn, busy) {
    var spinner = btn.querySelector('.loading__spinner');
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
    btn.classList.toggle('loading', busy);
    if (spinner) spinner.classList.toggle('hidden', !busy);
    if (busy) btn.disabled = true; else syncState(btn);
  }

  function goToCheckout() {
    window.location.href = root + 'checkout';
  }

  async function variantInCart(variantId) {
    try {
      var r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      var cart = await r.json();
      return (cart.items || []).some(function (i) { return String(i.variant_id) === String(variantId); });
    } catch (e) { return false; }
  }

  document.addEventListener('click', async function (evt) {
    var btn = evt.target.closest('[data-shop-now]');
    if (!btn) return;
    evt.preventDefault();
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

    var form = formFor(btn);
    if (!form) return;
    if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

    var data = new FormData(form);
    data.delete('sections');
    data.delete('sections_url');
    var variantId = data.get('id');
    if (!variantId) return;

    clearError(btn);
    setBusy(btn, true);
    try {
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      });
      var json = {};
      try { json = await res.json(); } catch (e) {}
      if (res.ok && !json.status) {
        var requested = parseInt(data.get('quantity') || '1', 10);
        var added = parseInt(json.quantity || requested, 10);
        if (added < requested) {
          // Shopify added only the units in stock: say so, then continue to checkout.
          showError(btn, (window.tpcShopNowStrings && window.tpcShopNowStrings.limited ||
            'Only {{ count }} available. Continuing to checkout with {{ count }}.').replace(/\{\{ count \}\}/g, added));
          setTimeout(goToCheckout, 2500);
          return;
        }
        goToCheckout();
        return;
      }
      // e.g. the only available unit is already in the cart: continue to checkout with the existing cart.
      if (res.status === 422 && (await variantInCart(variantId))) {
        goToCheckout();
        return;
      }
      showError(btn, json.description || json.message || fallbackError);
      setBusy(btn, false);
    } catch (e) {
      showError(btn, fallbackError);
      setBusy(btn, false);
    }
  });

  function watch(btn) {
    var form = formFor(btn);
    if (!form || btn.__tpcWatched) return;
    btn.__tpcWatched = true;
    var obs = new MutationObserver(function () { syncState(btn); });
    var atc = form.querySelector('[name="add"]');
    var idInput = form.querySelector('input[name="id"]');
    if (atc) obs.observe(atc, { attributes: true, attributeFilter: ['disabled'] });
    if (idInput) obs.observe(idInput, { attributes: true, attributeFilter: ['disabled', 'value'] });
    form.addEventListener('change', function () { syncState(btn); });
    syncState(btn);
  }

  function init() { document.querySelectorAll('[data-shop-now]').forEach(watch); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Variant changes in Dawn re-render the buy-buttons block; re-attach watchers when that happens.
  new MutationObserver(function () { init(); }).observe(document.documentElement, { childList: true, subtree: true });
  // Restore state when returning from checkout via the back button (bfcache).
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-shop-now]').forEach(function (b) { setBusy(b, false); });
  });
})();
